import { httpClient } from '../api/http-client';

export interface Permission {
  id: string;
  nombre: string;
  descripcion: string | null;
  activo: boolean;
  creadoEn: string;
  actualizadoEn: string;
}

export interface CreatePermissionData {
  nombre: string;
  descripcion?: string;
}

export interface UpdatePermissionData {
  nombre?: string;
  descripcion?: string;
}

export interface PermissionsQueryParams {
  page?: number;
  limit?: number;
  search?: string;
  activo?: boolean;
}

export interface PaginatedPermissionsResponse {
  data: Permission[];
  meta: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
    hasNext: boolean;
    hasPrevious: boolean;
  };
}

export class PermissionsService {
  private static readonly BASE_URL = '/permissions';

  static async getPermissions(params: PermissionsQueryParams = {}): Promise<PaginatedPermissionsResponse> {
    const queryParams = new URLSearchParams();
    
    if (params.page) queryParams.set('page', params.page.toString());
    if (params.limit) queryParams.set('limit', params.limit.toString());
    if (params.search) queryParams.set('search', params.search);
    if (params.activo !== undefined) queryParams.set('activo', params.activo.toString());

    const url = `${this.BASE_URL}${queryParams.toString() ? `?${queryParams}` : ''}`;
    const response = await httpClient.get<{ data: PaginatedPermissionsResponse }>(url);
    return response.data.data;
  }

  static async getPermission(id: string): Promise<Permission> {
    const response = await httpClient.get<{ data: Permission }>(`${this.BASE_URL}/${id}`);
    return response.data.data;
  }

  static async createPermission(data: CreatePermissionData): Promise<Permission> {
    const response = await httpClient.post<{ data: Permission }>(this.BASE_URL, data);
    return response.data.data;
  }

  static async updatePermission(id: string, data: UpdatePermissionData): Promise<Permission> {
    const response = await httpClient.patch<{ data: Permission }>(`${this.BASE_URL}/${id}`, data);
    return response.data.data;
  }

  static async togglePermissionStatus(id: string): Promise<Permission> {
    const response = await httpClient.patch<{ data: Permission }>(`${this.BASE_URL}/${id}/toggle-status`);
    return response.data.data;
  }

  static async deletePermission(id: string): Promise<void> {
    await httpClient.delete(`${this.BASE_URL}/${id}`);
  }
}